import { ERROR_CODES } from './errorCodes';
import {ax as axios} from './useAxiosLoader';
import { refreshAccessToken } from '../services/auth';

const baseURL = import.meta.env.VITE_API_BASE_URL

// Todo: handle errors
const handleApiErrors = async (err) => {
  // Opt-out for background requests that must never navigate the user away.
  // The PostCast coverage check fires every turn of a live voice interview, so
  // it is the request most likely to be the first to see an expired token — and
  // a redirect to /logout mid-interview would end the call. Callers that set
  // this handle their own failures.
  if (err.config?.skipGlobalErrorHandling) {
    throw err;
  }

  if (!err.response) {
    // 'You are offline. Please reconnect to the internet'))
    throw err;
  } else if (err.response.status === 401) {
      if (err.config?.url?.includes('/teams/user_invitation')) {
        throw err;
      }
      if (!err.config?._retriedAfterRefresh) {
        let tokenResponse = null;
        try {
          tokenResponse = await refreshAccessToken();
        } catch {
          // Refresh failed: the session is gone, so fall through to logout.
        }
        if (tokenResponse) {
          return axios({
            ...err.config,
            _retriedAfterRefresh: true,
            headers: { ...err.config.headers, Authorization: `Bearer ${tokenResponse.access_token}` },
          }).catch(handleApiErrors);
        }
      }
      window.location.href = "/logout?redirectUrl=" + encodeURIComponent(window.location.pathname);
      throw err;
  }else if (err.response.status === 403) {
    // Only redirect to blocked page if it's actually a blocked user
    if (err.response.data?.code === ERROR_CODES.USER_BLOCKED) {
      window.location.href = "/blocked";
    }
    throw err;
  }else if (err.response.status === 402) {
    let current_path = window.location.pathname;
    let context = "";
    try{
      context = current_path.split("/")[1];
    }
    catch(e){
      // do nothing
    }
    if(context === "analytics"){
      window.location.href = "/payments/trial-expired-analytics";
      throw err;
    }else{
      let error_code = err.response?.data?.code;
      if(error_code === ERROR_CODES.ORG_ADMIN_PLAN_EXPIRED){
        window.location.href = "/org/payments/plan-expired?role=admin&reason=expired";
        throw err;
      }
      else if(error_code === ERROR_CODES.ORG_MEMBER_PLAN_EXPIRED){
        window.location.href = "/org/payments/plan-expired?role=member&reason=expired";
        throw err;
      }
      else if(error_code === ERROR_CODES.ORG_ADMIN_NO_SUBSCRIPTION){
        window.location.href = "/org/payments/plan-expired?role=admin&reason=no_subscription";
        throw err;
      }
      else if(error_code === ERROR_CODES.ORG_MEMBER_NO_SUBSCRIPTION){
        window.location.href = "/org/payments/plan-expired?role=member&reason=no_subscription";
        throw err;
      }
      else if(error_code === ERROR_CODES.CREDIT_CARD_NEEDED_FOR_TRIAL){
        window.location.href = "/trial-start";
        throw err;
      }
      else if(error_code === ERROR_CODES.USER_PLAN_EXPIRED){
        window.location.href = "/payments/plan-expired";
        throw err;
      }
      window.location.href = "/payments/trial-expired";
      throw err;
    }
  }else if (err.response.status === 429) {
    if (window.location.pathname !== "/rate-limited") {
      window.location.href = "/rate-limited";
    }
    throw err;
  }else if (err.response.status === 422) {
    // check for linkedin account not connected error
    let errors = err.response.data?.errors;
    if(errors && errors.length > 0){
      let error = errors[0];
      if(error === "No LinkedIn account found"){
        window.location.href = "/integrations/linkedin";
        throw err;
      }
    }
    throw err;
  }
  else {
    throw err;
  }
};


const makeRequest = async (request) => {
  return axios({
    baseURL,
    ...request,
  })
    .catch(handleApiErrors)
    .then((response) => response.data);
};

export default makeRequest;
